export default __webpack_public_path__ + "static/assets/5c27c4294b52c26ecf6b2d0745a4da83.jpg";